/**
 * Success state display for the infrastructure import modal.
 *
 * Extracted from ImportModal.tsx (Sub-PR 6.4).
 */

import { useTranslation } from 'react-i18next'
import { CheckCircle2 } from 'lucide-react'
import type { ImportExecuteResult } from '../../../types/infrastructure'

interface ImportSuccessDisplayProps {
  result: ImportExecuteResult
  onClose: () => void
}

export function ImportSuccessDisplay({
  result,
  onClose,
}: ImportSuccessDisplayProps): React.ReactElement {
  const { t } = useTranslation('cases')

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100 dark:bg-green-950/50">
        <CheckCircle2 className="h-8 w-8 text-green-600 dark:text-green-400" />
      </div>
      <h3 className="mt-4 text-lg font-semibold text-slate-900 dark:text-white">
        {t('infrastructure.import.importComplete')}
      </h3>
      <p className="mt-2 text-center text-slate-600 dark:text-slate-400">
        {t('infrastructure.import.successCount', { count: result.importedCount })}
        {result.skippedCount > 0 && (
          <span className="block text-sm text-slate-500 dark:text-slate-400">
            ({t('infrastructure.import.skippedDuplicates', { count: result.skippedCount })})
          </span>
        )}
      </p>
      <button
        onClick={onClose}
        className="mt-6 rounded-lg bg-blue-600 px-6 py-2 text-white hover:bg-blue-700"
      >
        {t('actions.done')}
      </button>
    </div>
  )
}
